import type { ReactiveVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';

type UseRefetchOnReactiveVarProps = {
  onRefetch: () => void;
  reactiveVar: ReactiveVar<boolean>;
};

export function useRefetchOnReactiveVar({ onRefetch, reactiveVar }: UseRefetchOnReactiveVarProps) {
  const value = useReactiveVar(reactiveVar);

  useEffect(() => {
    if (value) {
      onRefetch();
      reactiveVar(false);
    }
  }, [value, onRefetch, reactiveVar]);
}
